import type { CSSProperties } from 'react'

/**
 * A setting that takes effect the moment it moves. Every toggle in the
 * redesign writes immediately and toasts; none of them waits for a Save.
 *
 * The knob and the track are the one place flat colour is allowed — they are
 * marks, not surfaces, and a translucent switch reads as a disabled one.
 */

interface ToggleProps {
  on: boolean
  onChange: (next: boolean) => void
  /** The 32x18 variant, for dense rows inside a wizard or a notification list. */
  dense?: boolean
  label: string
  disabled?: boolean
  style?: CSSProperties
}

export function Toggle({ on, onChange, dense = false, label, disabled = false, style }: ToggleProps) {
  const track = dense ? { width: 32, height: 18 } : { width: 36, height: 20 }
  const knob = dense ? 14 : 16

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!on)}
      className="tab"
      style={{
        ...track,
        borderRadius: 99,
        border: 0,
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: on ? 'flex-end' : 'flex-start',
        background: on ? 'var(--color-accent)' : 'var(--w-track)',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        boxSizing: 'border-box',
        flex: 'none',
        transition: 'background .2s ease',
        ...style,
      }}
    >
      <span
        style={{
          width: knob,
          height: knob,
          borderRadius: 99,
          background: on ? 'var(--w-onaccent)' : 'var(--color-muted)',
        }}
      />
    </button>
  )
}
